const ID_TOKEN_KEY = "id_token";
const ID_USER_KEY = "id_user";
const USER_INFO = "user_info";
const ID_PHONE_KEY = "user_phone";
const USER_NAME = "user_name";
const CODE_MARCHAND = "code_marchand";
const ID_MARCHAND = "id_marchand";
const IS_MARCHAND = "is_marchand";
const USER_EMAIL = "user_email";
const USER_PRIVILEGE = "user_privilege";
const USER_ALLPRIVILEGE = "user_allprivilege";
/**
 * @description get token form localStorage
 */
export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};
export const saveUserPhone = (telephone) => {
    window.localStorage.setItem(ID_PHONE_KEY, telephone);
};
/**
 * @description get privilige form localStorage
 */
export const getPrivilege = () => {
    const privlg = window.localStorage.getItem(USER_PRIVILEGE);
    let privlgTable = [];
    if (privlg != null) {
        privlgTable = JSON.parse(privlg);
    }
    return privlgTable;
};
export const getAllPrivilege = () => {
    const privleg = window.localStorage.getItem(USER_ALLPRIVILEGE);
    let privlegTable = [];
    if (privleg != null) {
        privlegTable = JSON.parse(privleg);
    }
    return privlegTable;
};
export const destroyUserPrivilege = () => {
    window.localStorage.removeItem(USER_PRIVILEGE);
};
export const savePrivilege = (privilege) => {
    window.localStorage.setItem(USER_PRIVILEGE, privilege);
};
export const saveAllPrivilege = (allprivilege) => {
    window.localStorage.setItem(USER_ALLPRIVILEGE, allprivilege);
};
export const getUserPhone = () => {
    return window.localStorage.getItem(ID_PHONE_KEY);
};
export const setUserEmail = (email) => {
    window.localStorage.setItem(USER_EMAIL, email);
};
export const getUserEmail = () => {
    return window.localStorage.getItem(USER_EMAIL);
};
export const destroyUserEmail = () => {
    window.localStorage.removeItem(USER_EMAIL);
};
/**
 * @description get user form localStorage
 */
export const getUser = () => {
    return window.localStorage.getItem(ID_USER_KEY);
};
export const getUserName = () => {
    return window.localStorage.getItem(USER_NAME);
};
export const getIfMarchand = (defaultValue) => {
    const value = window.localStorage.getItem(IS_MARCHAND);
    if (value === null) {
        return defaultValue;
    }
    return value === 'true';
};
export const getCodeMarchand = () => {
    return window.localStorage.getItem(CODE_MARCHAND);
};
export const getIdMarchand = () => {
    return window.localStorage.getItem(ID_MARCHAND);
};
export const saveIfMarchand = (estMarchand) => {
    window.localStorage.setItem(IS_MARCHAND, estMarchand.toString());
};
export const saveIdMarchand = (marchand) => {
    window.localStorage.setItem(ID_MARCHAND, marchand);
};
export const saveCodeMarchand = (codeMarchand) => {
    window.localStorage.setItem(CODE_MARCHAND, codeMarchand);
};
export const saveUserName = (name) => {
    window.localStorage.setItem(USER_NAME, name);
};
export const destroyUserPhone = () => {
    window.localStorage.removeItem(ID_PHONE_KEY);
};
export const destroyUserName = () => {
    window.localStorage.removeItem(ID_PHONE_KEY);
};
export const destroyCodeMarchand = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};
export const destroyIfMarchand = () => {
    window.localStorage.removeItem(IS_MARCHAND);
};
/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token) => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};
/**
 * @description save user into localStorage
 * @param user: string
 */
export const saveUser = (user) => {
    window.localStorage.setItem(ID_USER_KEY, user);
};
export const saveUserInfo = (user_info) => {
    window.localStorage.setItem(USER_INFO, user_info);
};
export const getUserInfo = () => {
    return window.localStorage.getItem(USER_INFO);
};
export const destroyUserINfo = () => {
    window.localStorage.removeItem(USER_INFO);
};
/**
 * @description remove token form localStorage
 */
export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};
/**
 * @description remove user form localStorage
 */
export const destroyUser = () => {
    window.localStorage.removeItem(ID_USER_KEY);
};
export const destroyIdMarchand = () => {
    window.localStorage.removeItem(ID_MARCHAND);
};
export default { destroyUserPrivilege, getPrivilege, getAllPrivilege,
    savePrivilege, saveAllPrivilege, getToken, saveUserName, setUserEmail,
    getUserEmail, destroyUserEmail, getUserName, getUserPhone,
    saveUserPhone, destroyUserPhone, destroyUserName, saveToken,
    destroyToken, saveUser, destroyUser, getUser, getIfMarchand,
    saveIfMarchand, destroyIfMarchand, getCodeMarchand,
    saveCodeMarchand, destroyCodeMarchand, getIdMarchand, saveIdMarchand,
    destroyIdMarchand };
//# sourceMappingURL=JwtService.js.map